import type { ReactNode } from 'react'
import { PublicHeader } from './PublicHeader'
import { PublicFooter } from './PublicFooter'
import { GovBanner } from './GovBanner'

export function AuthLayout({
  title,
  subtitle,
  children,
  footerSlot,
}: {
  title: string
  subtitle?: string
  children: ReactNode
  footerSlot?: ReactNode
}) {
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-white focus:text-primary focus:px-3 focus:py-2 focus:rounded focus:shadow-lg"
      >
        Skip to main content
      </a>
      <GovBanner />
      <PublicHeader />
      <main id="main" className="flex-1 grid place-items-center px-4 py-12">
        <div className="w-full max-w-md">
          <h1 className="text-2xl sm:text-3xl font-bold text-primary">{title}</h1>
          {subtitle && <p className="mt-2 text-neutral-600">{subtitle}</p>}
          <div className="mt-6 bg-white border border-neutral-200 rounded-lg shadow-sm p-6 sm:p-8">
            {children}
          </div>
          {footerSlot && <div className="mt-6 text-sm text-neutral-600 text-center">{footerSlot}</div>}
        </div>
      </main>
      <PublicFooter />
    </div>
  )
}

export const inputBase =
  'w-full h-10 px-3 rounded border border-neutral-300 focus-visible:outline-2 focus-visible:outline-accent-turquoise focus-visible:outline-offset-2'

export const labelBase =
  'block text-xs font-semibold uppercase tracking-wide text-neutral-700 mb-1'

export const primaryButton =
  'w-full h-10 rounded bg-primary text-white font-semibold hover:bg-primary-dark disabled:opacity-60 focus-visible:outline-2 focus-visible:outline-accent-turquoise focus-visible:outline-offset-2'
